import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import React from 'react';

import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { Acompte } from '@europrocurement/l2d-modules/providers';

export type ProvisionUpdateType = {
    acompte: Acompte;
    onUpdate: (item: Acompte) => Promise<void>;
};

const ProvisionUpdate: React.FunctionComponent<ProvisionUpdateType> = function ({
    acompte,
    onUpdate,
}) {
    const formStructure: FormStructure[] = React.useMemo(
        () => [
            {
                type: 'header',
                label: "Modifier l'encaissement",
                name: 'main_informations',
            },
            {
                type: 'date',
                name: 'date',
                inputlabel: 'Date',
                disableFuture: true,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
            {
                type: 'text',
                name: 'reference',
                inputlabel: 'Référence',
                placeholder: 'REF001',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
            {
                type: 'text',
                name: 'note',
                inputlabel: 'Note',
                placeholder: 'Note de la transaction',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
        ],
        [],
    );

    type ProvisionFormObject = {
        date?: Date;
        reference?: string;
        note?: string;
    };

    const provisionFormObject: Partial<ProvisionFormObject> = {
        date: new Date(acompte.dreception || ''),
        reference: acompte.reference || undefined,
        note: acompte.note || undefined,
    };

    const formContext = useForm({
        mode: 'onTouched',
        defaultValues: provisionFormObject,
    });

    const valueOrUndefined = (fieldToTest?: string | null): string | undefined =>
        fieldToTest !== undefined && fieldToTest !== null && fieldToTest !== ''
            ? (fieldToTest as unknown as string)
            : undefined;

    const onSubmit = async () => {
        const updatedAcompte: Acompte = {
            ...acompte,
            dreception: formContext.getValues().date,
            reference: valueOrUndefined(formContext.getValues().reference as unknown as string),
            note: valueOrUndefined(formContext.getValues().note as unknown as string),
        };

        await onUpdate(updatedAcompte);
    };

    const formProps = {
        formContext,
        onSubmit,
        formObject: {},
        submitButton: {
            displayed: false,
        },
    };

    return (
        <>
            <FlexyForm
                {...formProps}
                formStructure={formStructure}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    gap: '32px',
                    marginTop: '10px',
                }}
            >
                <Button
                    variant="contained"
                    sx={{ backgroundColor: 'primary.dark', padding: '16px 24px' }}
                    onClick={onSubmit}
                >
                    Valider
                </Button>
            </Box>
        </>
    );
};

export default ProvisionUpdate;
